import {Expose, Type} from 'class-transformer';
import {ProjectApiModel} from './project.api-model';

export class EventParticipationRequestVehicleApiModel {
  @Expose() public id: number;
  @Expose() public request?: any;
  @Expose()
  @Type(() => ProjectApiModel)
  public project: ProjectApiModel | string | null;
  @Expose() public position: number;
  @Expose() public projectSlugSnapshot: string | null;
  @Expose() public projectIdentitySnapshot: string | null;
}
